<template>
  <m-dialog ref="dlgKelasLuring" :isclose="true" :btnsave="false" :fullscreen="true" title="Informasi Kelas">
    <v-container class="my-10" v-if="info.completed_by && info.is_complete == 0">
      <!--      Ajuan Perbaikan -->
      <v-card flat>
        <v-card-title class="headline mx-4">Identitas dan Persyaratan Penggunaan</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="ma-0 py-0">
          <v-form v-if="current_instansi.id == 55" autocomplete="false" @submit.prevent data-vv-scope="form" lazy-validation>
            <v-card flat class="pa-0 mb-5">
              <v-card-text>
                <template v-for="(item, key) in schema">
                  <div :key="key">
                    <v-row wrap class="mx-2">
                      <template v-for="(form, i) in item.forms">
                        <v-col :key="i" class="my-2 py-0" v-bind="form.grid">
                          <div v-if="form.component == 'VLabel'" :class="form.class">
                            <div class="text-xl-body-1 font-weight-bold">{{ form.properties.label }}</div>
                          </div>
                          <component v-else-if="form.component == 'VRadioGroup'" :is="form.component" v-model="model[form.model]" :class="form.class">
                            <template v-slot:label>
                              <div>{{ form.properties.label }}</div>
                            </template>
                            <v-radio v-for="(pilih, index) in form.pilihan" :key="index" :value="pilih.value">
                              <template v-slot:label>
                                <div>{{ pilih.keterangan }}</div>
                              </template>
                            </v-radio>
                          </component>

                          <template v-else>
                            <span v-if="form.component == 'datetime' || form.component == 'wysiwyg'">{{ form.properties.label }}</span>
                            <component
                              :is="form.component"
                              outlined
                              dense
                              :disabled="form.properties.disabled"
                              v-bind="form.properties"
                              v-model="model[form.model]"
                              :data-vv-name="form.validation && form.validation.dataVvName ? form.validation.dataVvName : ''"
                              :data-vv-as="form.validation && form.validation.dataVvAs ? form.validation.dataVvAs : ''"
                              v-validate="form.validation && form.validation.vValidate ? form.validation.vValidate : ''"
                              :class="form.class"
                              :error-messages="form.validation && form.validation.errorMessages ? errors.collect(form.validation.errorMessages) : ''"
                            >
                              <template slot="item" slot-scope="data">
                                <div v-if="form.properties.name == 'jenis'">
                                  {{ data.item.keterangan }}
                                  <span> </span>
                                </div>
                                <span v-else>{{ data.item.nama }}</span>
                              </template>
                            </component>
                          </template>
                        </v-col>
                      </template>
                    </v-row>
                  </div>
                </template>
              </v-card-text>
            </v-card>
          </v-form>
        </v-card-text>
        <v-card-actions class="mx-4">
          <v-row no-gutters>
            <v-col cols="12">
              <p class="black--text mx-5 pb-0 mb-0">
                Dengan ini saya bersedia mengikuti pelaksanaan <strong>Diklat {{ current_instansi.nama }} </strong> dari awal sampai dengan akhir pembelajaran dan menyatakan data
                yang saya ajukan adalah benar.
              </p>
            </v-col>
            <v-col cols="12">
              <v-checkbox class="black--text mx-5" v-model="agreed" label="Saya menyetujui persyaratan penggunaan"></v-checkbox>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="submitPerbaikan" :disabled="!agreed" color="primary">AJUKAN PERBAIKAN</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
    <v-card class="rounded-lg elevation-0 pa-5 mt-5" v-else-if="info.is_konfirmasi">
      <v-row class="lg-mt-5">
        <v-col cols="12" sm="12" class="ml-4">
          <div>
            <p class="grey--text my-0 pb-0">
              Nama Kelas
            </p>
            <p class="primary--text font-weight-bold body-1">{{ pVal(info, "nama") }} {{ pVal(info, "angkatan") }}</p>
            <p class="grey--text my-0 pb-0">
              Jadwal Pelaksanaan
            </p>
            <p>{{ pVal(info, "tanggal_mulai") | toD }} s/d {{ pVal(info, "tanggal_selesai") | toD }}</p>
            <div v-if="current_instansi.id !== 55">
              <m-alert prominent type="info" show>
                <template v-slot:default>
                  <span class="black--text"
                    >Akses Modul Pembelajaran kelas <strong>{{ pVal(info, "nama") }} {{ pVal(info, "angkatan") }}</strong> tersedia
                    {{ isReady ? "pada tautan berikut ini" : "H-2 sebelum tanggal awal Pelaksanaan Kelas" }} <br v-if="isReady" /><br v-if="isReady" /><m-button
                      class="mt-n1 px-2 mt-2"
                      color="success"
                      v-if="isReady"
                      textButton="Tautan LMS"
                      action="toLink"
                      @toLink="toLink(info)"
                    ></m-button>
                    <br /><br />Jika terjadi kendala terkait Layanan Pembelajaran hubungi Helpdesk melalui tautan berikut <a :href="current_instansi.url_telegram">BANTUAN</a></span
                  >
                </template>
              </m-alert>
            </div>
            <!--            untuk kegiatan selain luring pmm-->
            <div class="py-4" v-else>
              <span v-html="info.keterangan"></span>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row v-if="false">
        <v-col cols="12">
          <ListPengelola :kelas="info" />
        </v-col>
      </v-row>
    </v-card>
    <v-container class="my-10" v-else>
      <v-card flat>
        <v-card-title class="headline mx-4">Identitas dan Persyaratan Penggunaan</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="ma-0 py-0">
          <v-form v-if="current_instansi.id == 55" autocomplete="false" @submit.prevent data-vv-scope="form" lazy-validation>
            <v-card flat class="pa-0 mb-5">
              <v-card-text>
                <template v-for="(item, key) in schema">
                  <div :key="key">
                    <v-row wrap class="mx-2">
                      <template v-for="(form, i) in item.forms">
                        <v-col :key="i" class="my-2 py-0" v-bind="form.grid">
                          <div v-if="form.component == 'VLabel'" :class="form.class">
                            <div class="text-xl-body-1 font-weight-bold">{{ form.properties.label }}</div>
                          </div>
                          <component v-else-if="form.component == 'VRadioGroup'" :is="form.component" v-model="model[form.model]" :class="form.class">
                            <template v-slot:label>
                              <div>{{ form.properties.label }}</div>
                            </template>
                            <v-radio v-for="(pilih, index) in form.pilihan" :key="index" :value="pilih.value">
                              <template v-slot:label>
                                <div>{{ pilih.keterangan }}</div>
                              </template>
                            </v-radio>
                          </component>

                          <template v-else>
                            <span v-if="form.component == 'datetime' || form.component == 'wysiwyg'">{{ form.properties.label }}</span>
                            <component
                              :is="form.component"
                              outlined
                              dense
                              :disabled="form.properties.disabled"
                              v-bind="form.properties"
                              v-model="model[form.model]"
                              :data-vv-name="form.validation && form.validation.dataVvName ? form.validation.dataVvName : ''"
                              :data-vv-as="form.validation && form.validation.dataVvAs ? form.validation.dataVvAs : ''"
                              v-validate="form.validation && form.validation.vValidate ? form.validation.vValidate : ''"
                              :class="form.class"
                              :error-messages="form.validation && form.validation.errorMessages ? errors.collect(form.validation.errorMessages) : ''"
                            >
                              <template slot="item" slot-scope="data">
                                <div v-if="form.properties.name == 'jenis'">
                                  {{ data.item.keterangan }}
                                  <span> </span>
                                </div>
                                <span v-else>{{ data.item.nama }}</span>
                              </template>
                            </component>
                          </template>
                        </v-col>
                      </template>
                    </v-row>
                  </div>
                </template>
              </v-card-text>
            </v-card>
          </v-form>
        </v-card-text>
        <v-card-actions class="mx-4">
          <v-row no-gutters>
            <v-col cols="12">
              <p class="black--text mx-5 pb-0 mb-0">
                Dengan ini saya bersedia mengikuti pelaksanaan <strong>Diklat {{ current_instansi.nama }} </strong> dari awal sampai dengan akhir pembelajaran.
              </p>
            </v-col>
            <v-col cols="12">
              <v-checkbox class="black--text mx-5" v-model="agreed" label="Saya menyetujui persyaratan penggunaan"></v-checkbox>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="submitRegistrasi" :disabled="!agreed" color="primary">LANJUT</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </m-dialog>
</template>

<script>
import subDays from "date-fns/sub_days";
import ListPengelola from "../components/ListPengelola.vue";
import format from "date-fns/format";

export default {
  components: {
    ListPengelola
  },
  provide() {
    return { parentValidator: this.$validator };
  },
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      model: {
        nama: "",
        simpkb_id: "",
        belajar_id: "",
        nik: "",
        tanggal_lahir: "",
        usia: "",
        jenis_ptk: "",
        mapel: "",
        npsn: "",
        jenjang: "",
        asal_sekolah: "",
        lama_mengajar: "",
        no_telpon: ""
      },
      dialog: false,
      info: {
        nama: "",
        keterangan: "",
        tanggal_mulai: "",
        tanggal_selesai: ""
      },
      pengelola: [],
      defInfo: {
        nama: "",
        keterangan: "",
        tanggal_mulai: "",
        tanggal_selesai: ""
      },
      agreed: false
    };
  },

  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.info = obj ? obj : this.defInfo;
      this.dialog = true;
      this.model = { ...this.current_user };
      this.model.nama = this.current_user.nama;
      this.model.nik = this.current_user.nik;
      this.model.lama_mengajar = this.current_user.lama_mengajar;
      this.model.npsn = this.current_user.npsn;
      this.model.no_telpon = this.current_user.no_telpon;
      this.model.jenjang = this.current_user.jenjang.keterangan;
      this.model.jenis_ptk = this.current_user.info_guru.ptk.m_jenis_ptk ? this.current_user.info_guru.ptk.m_jenis_ptk.jenis_ptk : null;
      this.model.mapel = this.current_user.info_guru.ptk.m_mapel_ukg ? this.current_user.info_guru.ptk.m_mapel_ukg.keterangan : "-";
      this.model.tanggal_lahir = this.current_user.tanggal_lahir;
      let x = this.$refs.dlgKelasLuring.open();
      this.$validator.reset();
      return x;
    },

    toLink(val) {
      window.open(val.url_kelas, "_blank");
    },

    submitAgreement() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          this.model.tanggal_mulai = format(this.model.tanggal_mulai, "YYYY-MM-DD HH:mm:ss");

          return this.$store.dispatch("user/persetujuan", { instansi_id: this.instansi_id, data: { is_konfirmasi: 1, kelas_id: this.info.id } }).then(res => {
            if (res && res.id) {
              this.$info("Anda telah melakukan konfirmasi kegiatan pembelajaran");
              this.info = res.kelas;
              this.info.is_konfirmasi = 1;
            }
          });
        })
        .catch(e => e);
    },

    submitRegistrasi() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          let objPost = { ...this.model };
          objPost.tanggal_lahir = format(this.model.tanggal_lahir, "YYYY-MM-DD");
          objPost.is_konfirmasi = 1;
          objPost.kelas_id = this.info.id;

          return this.$store.dispatch("user/persetujuan", { instansi_id: this.instansi_id, data: objPost }).then(res => {
            if (res && res.id) {
              this.$info("Anda telah melakukan konfirmasi kegiatan pembelajaran");
              this.info.is_konfirmasi = res.is_konfirmasi;
            }
          });
        })
        .catch(e => e);
    },

    submitPerbaikan() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          let objPost = { ...this.model };
          objPost.tanggal_lahir = format(this.model.tanggal_lahir, "YYYY-MM-DD");
          objPost.is_konfirmasi = 1;
          objPost.kelas_id = this.info.id;
          objPost.enrol_id = this.info.kelas_enrol_id;

          return this.$store.dispatch("user/ajuan_perbaikan", { instansi_id: this.instansi_id, data: objPost }).then(res => {
            if (res && res.id) {
              this.$info("Pengajuan ulang data berhasil");
              this.info.is_konfirmasi = res.is_konfirmasi;
              this.$refs.dlgKelasLuring.resolve();
            }
          });
        })
        .catch(e => e);
    }
  },

  computed: {
    schema() {
      return {
        schema: {
          forms: [
            {
              grid: { sm: 12, md: 12, lg: 12 },
              component: "VLabel",
              properties: {
                label: "Data SIMPKB"
              }
            },
            {
              grid: { sm: 12, md: 4, lg: 4 },
              component: "VTextField",
              model: "simpkb_id",
              properties: {
                name: "ID SIMPKB",
                disabled: true,
                placeholder: "Isikan ID SIMPKB",
                label: "ID SIMPKB"
              }
            },
            {
              grid: { sm: 12, md: 4, lg: 4 },
              component: "VTextField",
              model: "email_belajar_id",
              properties: {
                name: "belajar_id",
                disabled: true,
                placeholder: "Isikan Email belajar.id",
                label: "Email belajar.id"
              }
            },
            {
              grid: { sm: 12, md: 4, lg: 4 },
              component: "VTextField",
              model: "jenis_ptk",
              properties: {
                name: "Jenis PTK",
                disabled: true,
                placeholder: "Isikan Jenis PTK",
                label: "Jenis PTK"
              }
            },
            {
              grid: { sm: 12, md: 4, lg: 4 },
              component: "VTextField",
              model: "nik",
              properties: {
                name: "NIK",
                placeholder: "Isikan NIK",
                label: "NIK"
              },
              validation: {
                dataVvname: "NIK",
                dataVvas: "nik",
                vValidate: "required",
                errorMessages: "form.NIK"
              }
            },
            {
              grid: { sm: 12, md: 4, lg: 4 },
              component: "VTextField",
              model: "nama",
              properties: {
                name: "nama",
                disabled: true,
                placeholder: "Isikan Nama Lengkap",
                label: "Nama Lengkap"
              },
              validation: {
                dataVvname: "nama",
                dataVvas: "nama",
                vValidate: "required",
                errorMessages: "form.nama"
              }
            },
            // {
            //   grid: {sm: 12, md: 4, lg: 4},
            //   component: "VTextField",
            //   model: "usia",
            //   properties: {
            //     name: "Usia",
            //     disabled: true,
            //     placeholder: "Isikan Usia",
            //     label: "Usia"
            //   },
            //   validation: {
            //     dataVvname: "Usia",
            //     dataVvas: "usia",
            //     vValidate: "required",
            //     errorMessages: "form.usia"
            //   },
            // },
            {
              grid: { sm: 12, md: 4, lg: 4 },
              component: "VTextField",
              model: "no_telpon",
              properties: {
                name: "No Telepon",
                placeholder: "Isikan No Telepon",
                label: "No Telepon"
              },
              validation: {
                dataVvname: "No Telepon",
                dataVvas: "no_telpon",
                vValidate: "required|numeric",
                errorMessages: "form.No Telepon"
              }
            },
            {
              grid: { md: 4, lg: 4 },
              component: "datetime",
              model: "tanggal_lahir",
              properties: {
                name: "tanggal_lahir",
                valueZone: "Asia/Jakarta",
                zone: "Asia/Jakarta",
                placeholder: "Tanggal Lahir",
                type: "date",
                label: "Tanggal lahir",
                format: {
                  year: "numeric",
                  month: "long",
                  day: "numeric"
                },
                phrases: { ok: "Lanjut", cancel: "Batal" }
              },
              class: "timepicker"
            },

            {
              grid: { sm: 12, md: 12, lg: 12 },
              component: "VLabel",
              properties: {
                label: "Data Sekolah"
              }
            },
            {
              grid: { sm: 12, md: 4, lg: 4 },
              component: "VTextField",
              model: "npsn",
              properties: {
                disabled: false,
                name: "NPSN",
                placeholder: "Isikan NPSN",
                label: "NPSN Sekolah"
              },
              validation: {
                dataVvname: "NPSN Sekolah",
                dataVvas: "npsn",
                vValidate: "required|numeric",
                errorMessages: "form.NPSN"
              }
            },
            {
              grid: { sm: 12, md: 4, lg: 4 },
              component: "VTextField",
              model: "nama_sekolah",
              properties: {
                disabled: true,
                name: "Asal Sekolah",
                placeholder: "Isikan Asal Sekolah",
                label: "Asal Sekolah"
              },
              validation: {
                dataVvname: "Asal Sekolah",
                dataVvas: "nama_sekolah",
                vValidate: "required",
                errorMessages: "form.Asal Sekolah"
              }
            },
            {
              grid: { sm: 12, md: 4, lg: 4 },
              component: "VTextField",
              model: "jenjang",
              properties: {
                name: "Jenjang",
                disabled: true,
                placeholder: "Isikan Jenjang",
                label: "Jenjang"
              },
              validation: {
                dataVvname: "Jenjang",
                dataVvas: "jenjang",
                vValidate: "required",
                errorMessages: "form.jenjang"
              }
            },

            {
              grid: { sm: 12, md: 4, lg: 4 },
              component: "VTextField",
              model: "mapel",
              properties: {
                name: "Mapel",
                placeholder: "Isikan Mapel yang diampu",
                label: "Mapel yang diampu"
              },
              validation: {
                dataVvname: "Mapel",
                dataVvas: "mapel",
                vValidate: "required",
                errorMessages: "form.Mapel"
              }
            },
            {
              grid: { sm: 12, md: 4, lg: 4 },
              component: "VTextField",
              model: "lama_mengajar",
              properties: {
                name: "Lama Mengajar",
                placeholder: "Isikan Lama Mengajar",
                label: "Lama Mengajar (Dalam tahun)"
              },
              validation: {
                dataVvname: "Lama Mengajar",
                dataVvas: "lama_mengajar",
                vValidate: "required|numeric",
                errorMessages: "form.Lama Mengajar"
              }
            }
          ]
        }
      };
    },
    isReady() {
      let now = new Date();
      let start = subDays(this.info.tanggal_mulai, 2);
      return now >= start ? true : false;
    }
  }
};
</script>
<style>
.timepicker {
  color: rgba(0, 0, 0, 0.87);
  padding: 9px 8px 9px;
  max-width: 100%;
  width: 100%;
  border: 1px solid grey;
  outline: 1px;
  background: transparent;
  border-radius: 4px;
}

.vdatetime-input {
  width: 500px;
}
</style>
